import useGlobalFilterStore from './useGlobalFilterStore';

export default useGlobalFilterStore;
